import React, { useEffect, useContext, useState } from "react";
import { useForm } from "react-hook-form";
import "./Footer.css";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import { NavLink, Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import Common_Button from "../Common-Component/Common_Button/Common_Button";
import classNames from "classnames";
import { Context } from "../../utils/context";
import { AppSetup } from "../../utils/apis/common/Common";
import Successfull_Modal from "../Common_modal/Successfull_Modal/Successfull_Modal";
import Cookies from "js-cookie";
import {
  faFacebookF,
  faGoogle,
  faInstagram,
  faLinkedinIn,
  faXTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import Login_Modal from "../Common_modal/login_modal/Login_Modal";
const Footer = () => {
  const [modalShow, setModalShow] = useState(false);
  const { IMG_URL, postData } = useContext(Context);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const [emailerror, setemailErrors] = useState("");

  const onSubmit = async (d) => {
    const res = await postData(`/without-login/info-subscribe`, d);
    if (res?.success) {
      reset();
      setModalShow(true);
      setTimeout(() => {
        setModalShow(false);
        window.scrollTo(0, 0);
      }, 3000);
    } else {
      setemailErrors(res?.message);
    }
  };

  const [setups, setSetup] = useState();
  const getSetup = async () => {
    const res = await AppSetup();
    if (res?.success) {
      setSetup(res?.data);
    }
  };

  useEffect(() => {
    getSetup();
  }, []);

  const location = useLocation();

  const handleNavItemClick = (id) => {
    navigate(`/select-from-category/${id}`);
  };

  const { signin } = useContext(Context);

  const [modalLShow, setModalLShow] = useState(false);
  const [count, setCount] = useState(0);

  const handleNavClick = (link) => {

    console.log(link,"/my-account");
    
    if (link.path === "/my-account") {
      if (signin) {
        // Cookies.remove("local_mandai_security", { path: "/" });
       
        navigate("/my-account");
      } else {
          setModalLShow(true);
       
      }
    } else if (
      link.path === "/" ||
      link.path === "/shop" ||
      link.path === "/blog" ||
      link.path === "/near-me" ||
      link.path === "/about-us" ||
      link.path === "/contact-us" ||
       link.path === "/faq" ||
      link.path === "/become-seller" ||
      link.path === "/wishlist" ||
      link.path === "/privacy" ||
      link.path === "/terms" 
    ) {
      // Normal direct navigation
      navigate(link.path);

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      // Example: custom category navigation (if needed)
      handleNavItemClick(link.path);
    }
  };

  // const handleNavClick = (path) => {
  //   if (location.pathname === path) {
  //     window.scrollTo({
  //       top: 0,
  //       behavior: "smooth",
  //     });
  //   } else {
  //     navigate(path);
  //   }
  // };

  const socialIcons = [
    { icon: faFacebookF, link: "https://www.facebook.com/share/15BenkbRJh/" },
    {
      icon: faInstagram,
      link: "https://www.instagram.com/localmandai?utm_source=qr&igsh=MTh0MWlhMWdyMmY4ZQ==",
    },
    {
      icon: faLinkedinIn,
      link: "https://www.linkedin.com/in/local-mandai-8b6082296?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    {
      icon: faXTwitter,
      link: "https://www.threads.net/@localmandai",
    },
    {
      icon: faYoutube,
      link: "https://youtube.com/@localmandai?si=0U_avEI9uHY-HvTm",
    },
  ];

  return (
    <>
      <section className="Footer">
        <div className="container">
          <div className="row">
            <div className="col-xl-4 col-md-5 mb-3">
              <div className="left_side">
                <div className="logo_holder">
                  <img src={IMG_URL + setups?.image} className="logo_img" />
                </div>
                <p className="info_text">
                  Local Mandai connects local sellers and buyers, making
                  shopping easy, fast, and rewarding.
                </p>

                <div className="info_holder">
                  <div className="call_holder ">
                    <div className="icon_holder">
                      <FontAwesomeIcon
                        icon={faLocationDot}
                        className="inner_icon"
                      />{" "}
                    </div>

                    <p className="inner_text">{setups?.address}</p>
                  </div>
                  <div className="call_holder ">
                    <div className="icon_holder">
                      <FontAwesomeIcon
                        icon="fa-solid fa-phone"
                        className="inner_icon"
                      />{" "}
                    </div>
                    <p className="inner_text">{setups?.contact_no}</p>
                  </div>
                  <div className="call_holder">
                    <div className="icon_holder">
                      <FontAwesomeIcon
                        icon="fa-solid fa-envelope"
                        className="inner_icon"
                      />
                    </div>
                    <p className="inner_text">{setups?.email}</p>
                  </div>
                </div>

                <div className="icons_holder">
                  {socialIcons.map((item, index) => (
                    <div className="squr_box">
                      <div className="icon_holder">
                        <a
                          key={index}
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="link"
                        >
                          <FontAwesomeIcon
                            icon={item?.icon}
                            className="icon_class"
                          />
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-xl-8 col-md-7">
              <div className="row">
                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6">
                  <div className="col_div">
                    <p className="footer_section_title">Quick Links</p>
                    <Nav>
                      <div className="first_nav_div">
                        {[
                          { path: "/", label: "Home" },
                          { path: "/shop", label: "Shop" },
                          { path: "/contact-us", label: "Contact Us" },
                          { path: "/blog", label: "Blog" },
                          { path: "/become-seller", label: "Become Seller" },
                        ].map((item) => (
                          <Nav.Item key={item.path}>
                            <NavLink
                              as={Link}
                              to={item.path}
                              onClick={(e) => {
                                e.preventDefault(); // prevent default navigation first
                                handleNavClick(item);
                              }}
                              className={
                                location.pathname === item.path
                                  ? "active nav-link"
                                  : "nav-link"
                              }
                            >
                              {item.label}
                            </NavLink>
                          </Nav.Item>
                        ))}
                      </div>
                    </Nav>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4 col-md-4  col-sm-4 col-6">
                  <div className="col_div">
                    <p className="footer_section_title">Support</p>

                    <Nav>
                      <div className="first_nav_div">
                        {[
                          {
                            path: "/terms",
                            label: "Terms & Condition",
                          },
                          {
                            path: "/privacy",
                            label: "Privacy Policy",
                          },
                          {
                            path: "/my-account",
                            label: "Your Account",
                          },
                          { path: "/wishlist", label: "Your Wishlist" },
                          { path: "/faq", label: "FAQs" },
                        ].map((item) => (
                          <Nav.Item key={item.path}>
                            <NavLink
                              as={Link}
                              to={item.path}
                              onClick={(e) => {
                                e.preventDefault(); // prevent default navigation first
                                handleNavClick(item);
                              }}
                              className={
                                location.pathname === item.path
                                  ? "active nav-link"
                                  : "nav-link"
                              }
                            >
                              {item.label}
                            </NavLink>
                          </Nav.Item>
                        ))}
                      </div>
                    </Nav>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6">
                  <div className="col_div">
                    <p className="footer_section_title">App Link</p>

                    <div className="imgs_holder">
                      <img
                        src="/assets/Image/footer/img1.png"
                        className="app_img"
                      />
                      <img
                        src="/assets/Image/footer/img2.png"
                        className="app_img"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer_text_div">
          <p className="footer_text">
            © {new Date().getFullYear()} Local Mandai All Rights Reserved |
            Developed by{" "}
            <Link
              target="_blank"
              className="link_text"
              to="https://profcymaglobal.com/"
            >
              Profcyma Solutions Pvt Ltd
            </Link>
          </p>
        </div>
      </section>

      <Login_Modal
        key={count}
        show={modalLShow}
        onHide={() => setModalLShow(false)}
      />

      {/* old footer */}
      {/* <section className="footer">
        <Container>
          <div className="footer-banner">
            <div className="footer-bannermain">
              <div className="footer-imgdiv">
                <img
                  className="footerimg"
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/Image/footer/individual.png"
                  }
                  alt="Logo"
                />
              </div>

              <div className="ban-contentmain">
                <div className="row">
                  <div className="col-xxl-6 col-xl-6 col-lg-8 col-md-9 col-sm-12 ">
                    <div className="banconts">
                      <h4 className="newssetl">
                        Subscribe to our newsletter to get updates on our latest
                        collections for you
                      </h4>
                      <p className="getss">
                        Get Special deals with our subscription
                      </p>
                      <div className="email-box">
                        <Form onSubmit={handleSubmit(onSubmit)}>
                          <InputGroup className="mb-3">
                            <Form.Control
                              type="email"
                              placeholder="Email"
                              {...register("email", {
                                required: "Email Id required",
                                pattern: {
                                  value:
                                    /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z]{2,4})\.\2)([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
                                  message: "Email Id Invalid",
                                },
                              })}
                              className={classNames("", {
                                "is-invalid": errors?.email,
                              })}
                            />

                            <InputGroup.Text id="basic-addon2">
                              <button type="submit" className="subscribe-btn">
                                Subscribe
                              </button>
                            </InputGroup.Text>
                          </InputGroup>

                          {errors.email && (
                            <span className="text-danger">
                              {errors.email.message}
                            </span>
                          )}
                        </Form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-3 col-md-4  ">
              <Link as={Link} to="/">
                <img
                  className="headlogo"
                  src={IMG_URL + setups?.image}
                  alt="Logo"
                />
              </Link>
              <div className="text-area-loaction">
                <p>{setups?.address}</p>
              </div>
            </div>
            <div className="col-lg-6 col-md-8  ">
              <Nav
                defaultActiveKey="/"
                className="justify-content-lg-center justify-content-md-center justify-content-start"
              >
                <Nav.Item>
                  <NavLink
                    className="nav-link"
                    as={Link}
                    to="/"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    HOME
                  </NavLink>
                </Nav.Item>
                <Nav.Item>
                  <NavLink className="nav-link" as={Link} to="/near-me">
                    NEAR ME
                  </NavLink>
                </Nav.Item>
                <Nav.Item>
                  <NavLink className="nav-link" as={Link} to="/about-us">
                    ABOUT US
                  </NavLink>
                </Nav.Item>
                <Nav.Item>
                  <NavLink className="nav-link" as={Link} to="/contact-us">
                    CONTACT US
                  </NavLink>
                </Nav.Item>
                <Nav.Item>
                  <NavLink className="nav-link" as={Link} to="/privacy">
                    PRIVACY POLICY
                  </NavLink>
                </Nav.Item>
                <Nav.Item>
                  <NavLink className="nav-link" as={Link} to="/terms">
                    TERMS & CONDITIONS
                  </NavLink>
                </Nav.Item>
              </Nav>
              <div className="location-holder">
                <div className="call-holder me-4">
                  <FontAwesomeIcon
                    icon="fa-solid fa-phone"
                    className="call-icon me-2"
                  />{" "}
                  <span className="me-2">{setups?.contact_no}</span>
                </div>
                <div className="call-holder ">
                  <FontAwesomeIcon
                    icon="fa-solid fa-envelope"
                    className="call-icon me-2"
                  />
                  <span>{setups?.email}</span>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-5">
              <div className="address-holder">
                <div className="text-holder">
                  <p>Follow Us On:</p>
                </div>
                <div className="social-icon">
                  <Link
                    to={"https://www.facebook.com/share/15BenkbRJh/"}
                    target="blank"
                  >
                    {" "}
                    <img
                      className="sociallogo"
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/Image/Icon/facebook.png"
                      }
                      alt="sociallogo"
                    />
                  </Link>

                  <Link
                    to={
                      "https://www.instagram.com/localmandai?utm_source=qr&igsh=MTh0MWlhMWdyMmY4ZQ=="
                    }
                    target="blank"
                  >
                    {" "}
                    <img
                      className="sociallogo"
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/Image/Icon/instagram.png"
                      }
                      alt="sociallogo"
                    />
                  </Link>

                  <Link
                    to={
                      "https://www.linkedin.com/in/local-mandai-8b6082296?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                    }
                    target="blank"
                  >
                    {" "}
                    <img
                      className="sociallogo"
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/Image/Icon/linkdin.png"
                      }
                      alt="sociallogo"
                    />
                  </Link>
                  <Link
                    to={"https://www.threads.net/@localmandai"}
                    target="blank"
                  >
                    {" "}
                    <img
                      className="sociallogo"
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/Image/Icon/twitter.png"
                      }
                      alt="sociallogo"
                    />
                  </Link>
                  <Link
                    to={"https://youtube.com/@localmandai?si=0U_avEI9uHY-HvTm"}
                    target="blank"
                  >
                    <img
                      className="sociallogo"
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/Image/Icon/youtube.png"
                      }
                      alt="sociallogo"
                    />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className="copyright-holder  text-center">
                <p>
                  Copyright © {new Date().getFullYear()} All Rights Reserved.{" "}
                  <Link to="https://profcymaglobal.com/" target="___blank">
                    Developed by Profcyma.
                  </Link>{" "}
                </p>
              </div>
            </div>
          </div>
        </Container>
      </section> */}

      <Successfull_Modal
        message={`Successfully Subscribed`}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Footer;
